import React, { useState, useEffect, useRef } from 'react';

import { makeStyles } from 'design-system/product/theme';

import { LabelChoice } from '@scale/shared/types/params/annotation';
import AttributeShortcutSelect from './AttributeShortcutSelect';

interface AttributeShortcutSelectWrapperProps {
  attrKey: string;
  attrParams: $FIXME;
  selectedChoice?: string;
  isReadOnly?: boolean;
  handleSelect: (choice: LabelChoice) => void;
}

const useActiveElement = () => {
  const [active, setActive] = useState(document.activeElement);

  const handleFocusIn = () => {
    setActive(document.activeElement);
  };

  useEffect(() => {
    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);

  return active;
};

const AttributeShortcutSelectWrapper: React.FC<AttributeShortcutSelectWrapperProps> = ({
  attrKey,
  attrParams,
  selectedChoice,
  isReadOnly,
  handleSelect,
}) => {
  const classes = useStyles();

  const active = useActiveElement();
  const ref = useRef<HTMLDivElement>(null);

  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (active === ref.current && !isFocused) {
      setIsFocused(true);
    } else if (active !== ref.current && isFocused) {
      setIsFocused(false);
    }
  }, [active, isFocused]);

  return (
    <div className={classes.inputGrouping} key={attrKey} tabIndex={0} ref={ref}>
      {attrParams.choices &&
        attrParams.choices.map((c: LabelChoice, idx: number) => {
          return (
            <AttributeShortcutSelect
              key={(typeof c !== 'string' && c.choice) || (c as string)}
              tree={c}
              selectedChoice={selectedChoice}
              isReadOnly={isReadOnly}
              handleSelect={handleSelect}
              index={idx}
              isFocused={isFocused}
            />
          );
        })}
    </div>
  );
};

const useStyles = makeStyles({
  inputGrouping: {
    '&:focus': {
      borderLeft: '4px solid blue',
    },
  },
});

export default AttributeShortcutSelectWrapper;
